// esenz light — minimal

(() => {
  const mobileNavMenu = document.querySelector('.mobile-nav-menu');

  if (mobileNavMenu) {
    const setMobileNavOpen = (isOpen) => {
      mobileNavMenu.open = isOpen;
      document.documentElement.classList.toggle('mobile-nav-lock', isOpen);
    };

    mobileNavMenu.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('mobile-nav-lock', mobileNavMenu.open);
    });

    mobileNavMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMobileNavOpen(false));
    });

    document.addEventListener('click', (event) => {
      if (!mobileNavMenu.open || mobileNavMenu.contains(event.target)) return;
      setMobileNavOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMobileNavOpen(false);
    });
  }

  const modal = document.querySelector('[data-quiz-modal]');
  const openButtons = document.querySelectorAll('[data-quiz-open]');
  const closeButtons = document.querySelectorAll('[data-quiz-close]');

  const setModalOpen = (isOpen) => {
    if (!modal) return;
    modal.classList.toggle('is-open', isOpen);
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle('quiz-modal-lock', isOpen);
    if (isOpen) modal.dispatchEvent(new CustomEvent('quiz:open'));
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!modal) return;
      event.preventDefault();
      setModalOpen(true);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => setModalOpen(false));
  });

  if (modal && window.location.hash === '#quiz-modal') {
    window.setTimeout(() => setModalOpen(true), 120);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setModalOpen(false);
  });

  const quizzes = document.querySelectorAll('[data-esenz-quiz]');

  quizzes.forEach((quiz) => {
    const steps = Array.from(quiz.querySelectorAll('[data-quiz-step]'));
    const result = quiz.querySelector('[data-quiz-result]');
    const loader = quiz.querySelector('[data-quiz-loader]');
    const emailStep = quiz.querySelector('[data-quiz-email-step]');
    const progress = quiz.querySelector('[data-quiz-progress]');
    const currentCounter = quiz.querySelector('[data-quiz-current]');
    const totalCounter = quiz.querySelector('[data-quiz-total]');
    const backButton = quiz.querySelector('[data-quiz-back]');
    const nextButtons = quiz.querySelectorAll('[data-quiz-next]');
    const continueButtons = quiz.querySelectorAll('[data-quiz-continue]');
    const resetButton = quiz.querySelector('[data-quiz-reset]');
    const emailForm = quiz.querySelector('.quiz-email-form');
    const emailInput = quiz.querySelector('[data-quiz-email-input]');
    const skipEmailButton = quiz.querySelector('[data-quiz-skip-email]');
    const tagsInput = quiz.querySelector('[data-quiz-tags]');
    const noteInput = quiz.querySelector('[data-quiz-note]');
    const leadFrameName = 'quiz-lead-frame';
    let current = 0;
    let activeScreen = 'step';
    let loaderTimer = null;
    let answers = {};

    const screens = [...steps, loader, emailStep, result].filter(Boolean);

    const answerLabel = {
      goals: 'Wichtigste Ziele',
      gender: 'Geschlecht',
      age: 'Alter',
      training: 'Training',
      creatine_experience: 'Kreatin-Erfahrung',
      digestion: 'Verdauung',
      concerns: 'Themen',
      supplement_objection: 'Supplement-Hürde',
      routine_style: 'Routine',
      desired_result: 'Wunsch-Ergebnis'
    };

    const slugify = (value) => value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 42);

    const setProgress = (value) => {
      if (!progress) return;
      progress.style.width = `${value}%`;
    };

    const normalizeAnswerValue = (value) => Array.isArray(value) ? value.join(' + ') : value;

    const getResultType = () => {
      const goals = Array.isArray(answers.goals) ? answers.goals : [];
      const concerns = Array.isArray(answers.concerns) ? answers.concerns : [];
      const gender = answers.gender;
      const objection = answers.supplement_objection;
      const experience = answers.creatine_experience;
      const desiredResult = answers.desired_result;

      if (gender === 'Frau' && (concerns.includes('Zyklus') || goals.includes('Sportlicher aussehen'))) {
        return 'female-strength-balance';
      }

      if (
        concerns.includes('Magenschmerzen') ||
        concerns.includes('Blähbauch') ||
        objection === 'Magenprobleme' ||
        experience === 'Magen nicht vertragen'
      ) {
        return 'sensitive-stomach';
      }

      if (goals.includes('Kraft') || desiredResult === 'Mehr Kraft' || answers.training === '5x+ pro Woche') {
        return 'performance-builder';
      }

      if (goals.includes('Energie') || goals.includes('Fokus') || desiredResult === 'Mehr Energie' || desiredResult === 'Mehr Fokus') {
        return 'daily-energy-focus';
      }

      return 'routine-reset';
    };

    const updateLeadFields = () => {
      const answerEntries = Object.entries(answers).filter(([, value]) => value);
      const resultType = getResultType();
      const answerTags = answerEntries.flatMap(([key, value]) => {
        const values = Array.isArray(value) ? value : [value];
        return values.map((item) => `quiz-${slugify(key)}-${slugify(item)}`);
      });

      if (tagsInput) {
        tagsInput.value = ['quiz', 'kern-esenz', `quiz-result-${resultType}`, ...answerTags].join(',');
      }

      if (noteInput) {
        const summary = answerEntries.map(([key, value]) => `${answerLabel[key] || key}: ${normalizeAnswerValue(value)}`).join(' | ');
        noteInput.value = summary ? `Kern Esenz Quiz | Ergebnisprofil: ${resultType} | ${summary}` : 'Kern Esenz Quiz';
      }
    };

    const clearScreens = () => {
      screens.forEach((screen) => screen.classList.remove('is-active'));
    };

    const setBackButton = (isVisible) => {
      if (!backButton) return;
      backButton.hidden = !isVisible;
      backButton.disabled = !isVisible;
    };

    const showStep = (index) => {
      window.clearTimeout(loaderTimer);
      clearScreens();
      steps[index]?.classList.add('is-active');
      current = index;
      activeScreen = 'step';
      if (currentCounter) currentCounter.textContent = `${current + 1}`;
      if (totalCounter) totalCounter.textContent = `${steps.length}`;
      setProgress(((current + 1) / steps.length) * 92);
      setBackButton(current > 0);
    };

    const showResult = () => {
      window.clearTimeout(loaderTimer);
      clearScreens();
      result?.classList.add('is-active');
      activeScreen = 'result';
      setProgress(100);
      setBackButton(false);
      updateLeadFields();
    };

    const showEmailStep = () => {
      clearScreens();
      emailStep?.classList.add('is-active');
      activeScreen = 'email';
      setProgress(100);
      if (currentCounter) currentCounter.textContent = `${steps.length}`;
      if (totalCounter) totalCounter.textContent = `${steps.length}`;
      setBackButton(true);
      updateLeadFields();
      window.setTimeout(() => emailInput?.focus(), 120);
    };

    const showLoader = () => {
      clearScreens();
      loader?.classList.add('is-active');
      activeScreen = 'loader';
      setProgress(94);
      setBackButton(false);
      updateLeadFields();
      loaderTimer = window.setTimeout(() => {
        if (emailStep) {
          showEmailStep();
          return;
        }
        showResult();
      }, 3800);
    };

    const resetQuiz = () => {
      answers = {};
      window.clearTimeout(loaderTimer);
      quiz.querySelectorAll('.quiz-options button').forEach((button) => button.classList.remove('is-selected'));
      quiz.querySelectorAll('[data-quiz-continue]').forEach((button) => {
        button.disabled = true;
      });
      emailForm?.reset();
      updateLeadFields();
      showStep(0);
    };

    if (emailForm) {
      emailForm.setAttribute('target', leadFrameName);

      if (!document.querySelector(`iframe[name="${leadFrameName}"]`)) {
        const leadFrame = document.createElement('iframe');
        leadFrame.name = leadFrameName;
        leadFrame.title = 'Quiz Lead';
        leadFrame.hidden = true;
        quiz.appendChild(leadFrame);
      }
    }

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.closest('[data-quiz-step]');
        const stepName = step?.dataset.quizStepName;
        const answer = button.dataset.quizAnswer || button.textContent.trim();
        const isMulti = step?.hasAttribute('data-quiz-multiple');

        if (isMulti) {
          const selectedAnswers = new Set(Array.isArray(answers[stepName]) ? answers[stepName] : []);
          if (selectedAnswers.has(answer)) {
            selectedAnswers.delete(answer);
          } else {
            selectedAnswers.add(answer);
          }
          answers[stepName] = Array.from(selectedAnswers);
          button.classList.toggle('is-selected', selectedAnswers.has(answer));
          step.querySelectorAll('[data-quiz-continue]').forEach((continueButton) => {
            continueButton.disabled = selectedAnswers.size === 0;
          });
          updateLeadFields();
          return;
        }

        if (stepName) answers[stepName] = answer;

        button.closest('.quiz-options')?.querySelectorAll('[data-quiz-next]').forEach((option) => {
          option.classList.toggle('is-selected', option === button);
        });

        updateLeadFields();

        if (stepName === 'desired_result' || (!stepName && current >= steps.length - 1)) {
          window.setTimeout(() => {
            if (emailStep) showEmailStep();
            else if (loader) showLoader();
            else showResult();
          }, 180);
          return;
        }

        const nextIndex = Number.isFinite(Number.parseInt(button.dataset.quizNextStep, 10))
          ? Number.parseInt(button.dataset.quizNextStep, 10)
          : current + 1;

        window.setTimeout(() => showStep(nextIndex), 150);
      });
    });

    backButton?.addEventListener('click', () => {
      if (activeScreen === 'email') {
        showStep(steps.length - 1);
        return;
      }

      if (activeScreen === 'step' && current > 0) {
        showStep(current - 1);
      }
    });

    continueButtons.forEach((button) => {
      button.disabled = true;
      button.addEventListener('click', () => {
        const step = button.closest('[data-quiz-step]');
        const stepName = step?.dataset.quizStepName;
        const answer = answers[stepName];
        if (step?.hasAttribute('data-quiz-multiple') && (!Array.isArray(answer) || answer.length === 0)) return;

        updateLeadFields();
        window.setTimeout(() => showStep(current + 1), 150);
      });
    });

    emailForm?.addEventListener('submit', (event) => {
      if (!emailInput?.value.trim()) {
        event.preventDefault();
        emailInput?.focus();
        return;
      }

      updateLeadFields();
      window.setTimeout(showResult, 700);
    });

    skipEmailButton?.addEventListener('click', showResult);
    resetButton?.addEventListener('click', resetQuiz);
    modal?.addEventListener('quiz:open', resetQuiz);
    resetQuiz();
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerItems = document.querySelector('[data-cart-drawer-items]');
  const cartDrawerError = document.querySelector('[data-cart-drawer-error]');
  const cartDrawerTotal = document.querySelector('[data-cart-drawer-total]');
  const cartDrawerCount = document.querySelector('[data-cart-drawer-count]');
  const cartDrawerCloseButtons = document.querySelectorAll('[data-cart-drawer-close]');
  const isGerman = document.documentElement.lang?.toLowerCase().startsWith('de');
  const cartCopy = {
    emptyTitle: isGerman ? 'Dein Warenkorb ist leer.' : 'Your cart is empty.',
    emptyBody: isGerman ? 'Wähle dein Esenz Produkt aus und komm danach direkt hier zurück.' : 'Choose your Esenz product and come right back here.',
    emptyCta: isGerman ? 'Produkte ansehen' : 'View products',
    remove: isGerman ? 'Produkt entfernen' : 'Remove product',
    quantity: isGerman ? 'Menge ändern' : 'Change quantity',
    fixedQuantity: cartDrawer?.dataset.cartFixedQuantity || '',
    offerCorrected: cartDrawer?.dataset.cartOfferCorrected || '',
    supplyOne: cartDrawer?.dataset.cartSupplyOne || '',
    supplyTwo: cartDrawer?.dataset.cartSupplyTwo || '',
    errorFallback: isGerman ? 'Das hat gerade nicht geklappt. Bitte versuch es nochmal.' : 'Something went wrong. Please try again.'
  };

  const rootRoute = window.Shopify?.routes?.root || '/';
  const cartUrl = `${rootRoute}cart`;
  const productsUrl = `${rootRoute}products/kern-esenz`;
  const cartJsonUrl = `${rootRoute}cart.js`;
  const cartAddUrl = `${rootRoute}cart/add.js`;
  const cartChangeUrl = `${rootRoute}cart/change.js`;
  const kernPackagingImages = {
    dose: window.esenzCartImages?.dose || 'https://cdn.shopify.com/s/files/1/1017/8071/7916/files/kern-esenz-dose-packaging-option-2026-06-24.png?v=1782282523',
    beutel: window.esenzCartImages?.beutel || 'https://cdn.shopify.com/s/files/1/1017/8071/7916/files/kern-esenz-beutel-heller-hintergrund-2026-06.png?v=1780773301'
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = isGerman ? 'de-DE' : 'en-US';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  };

  const escapeHtml = (value = '') => value
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const showCartError = (message) => {
    if (!cartDrawerError) return;
    const cleanMessage = message || cartCopy.errorFallback;
    cartDrawerError.textContent = cleanMessage;
    cartDrawerError.hidden = false;
  };

  const clearCartError = () => {
    if (!cartDrawerError) return;
    cartDrawerError.textContent = '';
    cartDrawerError.hidden = true;
  };

  const setCartDrawerOpen = (isOpen) => {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-open', isOpen);
    cartDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle('cart-drawer-lock', isOpen);
    if (isOpen) {
      window.setTimeout(() => cartDrawer.querySelector('.cart-drawer-close')?.focus(), 80);
    }
  };

  const getCartErrorMessage = (payload) => {
    if (!payload) return cartCopy.errorFallback;
    if (typeof payload === 'string') return payload;
    if (payload.description) return payload.description;
    if (payload.message) return payload.message;
    if (payload.errors) {
      if (typeof payload.errors === 'string') return payload.errors;
      if (Array.isArray(payload.errors)) return payload.errors.join(' ');
      return Object.values(payload.errors).flat().join(' ');
    }
    return cartCopy.errorFallback;
  };

  const getLineItemImage = (item) => {
    const productHandle = (item.handle || item.product_handle || item.url || '').toString().toLowerCase();
    const packaging = (item.properties?.Verpackung || item.variant_title || '').toString().toLowerCase();
    if (productHandle.includes('kern-esenz') || item.product_title?.toLowerCase() === 'kern esenz') {
      if (packaging.includes('dose') || packaging.includes('jar')) return kernPackagingImages.dose;
      if (packaging.includes('beutel') || packaging.includes('pouch')) return kernPackagingImages.beutel;
    }
    return item.image || '';
  };

  const hasShakerOffer = (item) => {
    const bonus = (item.properties?.Bonus || '').toString().toLowerCase();
    const offer = (item.properties?.Angebot || '').toString().toLowerCase();
    return bonus.includes('shaker') || offer.includes('shaker');
  };

  const getCorrectedOfferLabel = (quantity) => {
    if (quantity === 1) return cartCopy.supplyOne;
    if (quantity === 2) return cartCopy.supplyTwo;
    return `${quantity} × ${cartCopy.supplyOne}`;
  };

  const getCorrectedOfferProperties = (item) => {
    const properties = { ...(item.properties || {}) };
    Object.keys(properties).forEach((key) => {
      if (key.toLowerCase() === 'bonus') delete properties[key];
    });
    properties.Angebot = getCorrectedOfferLabel(item.quantity);
    return properties;
  };

  const normalizeShakerOffers = async (cart) => {
    let normalizedCart = cart;
    let corrected = false;
    const invalidItems = cart.items.filter((item) => hasShakerOffer(item) && item.quantity !== 3);

    for (const item of invalidItems) {
      const response = await fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: getCorrectedOfferProperties(item)
        })
      });
      const payload = await response.json().catch(() => null);
      if (!response.ok) throw new Error(getCartErrorMessage(payload));
      normalizedCart = payload;
      corrected = true;
    }

    return { cart: normalizedCart, corrected };
  };

  const renderCartItem = (item, index) => {
    const productHandle = (item.handle || item.product_handle || item.url || '').toString().toLowerCase();
    const isKernItem = productHandle.includes('kern-esenz') || item.product_title?.toLowerCase() === 'kern esenz';
    const imageUrl = getLineItemImage(item);
    const image = imageUrl
      ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product_title)}" width="110" height="110" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span>${escapeHtml(item.variant_title)}</span>`
      : '';
    const properties = item.properties
      ? Object.entries(item.properties)
        .filter(([key, value]) => value && !key.startsWith('_'))
        .map(([key, value]) => `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`)
        .join('')
      : '';
    const quantityControl = hasShakerOffer(item)
      ? `<div class="cart-drawer-qty cart-drawer-qty--locked" aria-label="${escapeHtml(cartCopy.fixedQuantity)}">
          <span>${item.quantity}</span>
          <small>${escapeHtml(cartCopy.fixedQuantity)}</small>
        </div>`
      : `<div class="cart-drawer-qty" aria-label="${escapeHtml(cartCopy.quantity)}">
          <button type="button" data-cart-quantity-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
          <span>${item.quantity}</span>
          <button type="button" data-cart-quantity-change data-line="${index + 1}" data-quantity="${item.quantity + 1}">+</button>
        </div>`;

    return `
      <article class="cart-drawer-item" data-cart-drawer-line="${index + 1}">
        <a class="cart-drawer-item-image${isKernItem ? ' cart-drawer-item-image--kern' : ''}" href="${escapeHtml(item.url)}">${image}</a>
        <div class="cart-drawer-item-body">
          <div class="cart-drawer-item-top">
            <div>
              <a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>
              ${variant}
              ${properties}
            </div>
            <button type="button" class="cart-drawer-remove" data-cart-remove-line="${index + 1}" aria-label="${cartCopy.remove}">×</button>
          </div>
          <div class="cart-drawer-item-bottom">
            ${quantityControl}
            <strong>${formatMoney(item.final_line_price)}</strong>
          </div>
        </div>
      </article>
    `;
  };

  const renderCart = (cart) => {
    if (!cartDrawerItems || !cart) return;
    cartDrawer?.classList.toggle('is-empty', !cart.item_count);

    if (!cart.item_count) {
      cartDrawerItems.innerHTML = `
        <div class="cart-drawer-empty">
          <strong>${cartCopy.emptyTitle}</strong>
          <p>${cartCopy.emptyBody}</p>
          <a href="${productsUrl}">${cartCopy.emptyCta}</a>
        </div>
      `;
    } else {
      cartDrawerItems.innerHTML = cart.items.map(renderCartItem).join('');
    }

    if (cartDrawerTotal) cartDrawerTotal.textContent = formatMoney(cart.total_price);
    if (cartDrawerCount) cartDrawerCount.textContent = `(${cart.item_count})`;
  };

  const fetchCart = async () => {
    const response = await fetch(cartJsonUrl, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(cartCopy.errorFallback);
    return response.json();
  };

  const refreshCartDrawer = async ({ open = true, error = '' } = {}) => {
    try {
      const fetchedCart = await fetchCart();
      const normalized = await normalizeShakerOffers(fetchedCart);
      renderCart(normalized.cart);
      if (error) showCartError(error);
      else if (normalized.corrected) showCartError(cartCopy.offerCorrected);
      else clearCartError();
      if (open) setCartDrawerOpen(true);
      return normalized.cart;
    } catch (fetchError) {
      showCartError(fetchError.message || cartCopy.errorFallback);
      if (open) setCartDrawerOpen(true);
      return null;
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !cartDrawer) return;

    event.preventDefault();
    const submitButton = event.submitter || form.querySelector('button[type="submit"]');
    if (submitButton?.disabled) return;

    submitButton?.setAttribute('aria-busy', 'true');
    submitButton && (submitButton.disabled = true);

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      const payload = await response.json().catch(() => null);

      if (!response.ok) {
        await refreshCartDrawer({ open: true, error: getCartErrorMessage(payload) });
        return;
      }

      await refreshCartDrawer({ open: true });
    } catch (error) {
      await refreshCartDrawer({ open: true, error: error.message || cartCopy.errorFallback });
    } finally {
      submitButton?.removeAttribute('aria-busy');
      submitButton && (submitButton.disabled = false);
    }
  });

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-cart-drawer-open]');
    if (!opener || !cartDrawer) return;

    event.preventDefault();
    await refreshCartDrawer({ open: true });
  });

  document.addEventListener('click', async (event) => {
    const quantityButton = event.target.closest('[data-cart-quantity-change]');
    const removeButton = event.target.closest('[data-cart-remove-line]');

    if (quantityButton) {
      event.preventDefault();
      clearCartError();
      try {
        const response = await fetch(cartChangeUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: Number(quantityButton.dataset.line),
            quantity: Number(quantityButton.dataset.quantity)
          })
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok) {
          showCartError(getCartErrorMessage(payload));
          return;
        }
        renderCart(payload);
      } catch (error) {
        showCartError(error.message || cartCopy.errorFallback);
      }
    }

    if (removeButton) {
      event.preventDefault();
      clearCartError();
      try {
        const response = await fetch(cartChangeUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: Number(removeButton.dataset.cartRemoveLine),
            quantity: 0
          })
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok) {
          showCartError(getCartErrorMessage(payload));
          return;
        }
        renderCart(payload);
      } catch (error) {
        showCartError(error.message || cartCopy.errorFallback);
      }
    }
  });

  document.addEventListener('click', async (event) => {
    const checkoutLink = event.target.closest('.cart-drawer-checkout');
    if (!checkoutLink) return;

    event.preventDefault();
    const cart = await refreshCartDrawer({ open: true });
    if (cart) window.location.assign(checkoutLink.href);
  });

  document.addEventListener('submit', async (event) => {
    const checkoutButton = event.submitter;
    const cartForm = event.target.closest('form[action*="/cart"]');
    if (!cartForm || checkoutButton?.name !== 'checkout') return;

    event.preventDefault();
    const cart = await refreshCartDrawer({ open: false });
    if (cart) window.location.assign(`${rootRoute}checkout`);
  });

  cartDrawerCloseButtons.forEach((button) => {
    button.addEventListener('click', () => setCartDrawerOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setCartDrawerOpen(false);
  });

  if (cartDrawer) refreshCartDrawer({ open: false });

  const productMainImage = document.querySelector('[data-product-main-image]');
  const galleryButtons = document.querySelectorAll('[data-product-gallery-thumb]');
  const formatButtons = document.querySelectorAll('[data-product-format]');
  const productVariantInputs = document.querySelectorAll('[data-product-variant-id]');
  const productPackagingProperties = document.querySelectorAll('[data-product-packaging-property]');

  galleryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (!productMainImage || !button.dataset.image) return;

      productMainImage.src = button.dataset.image;
      if (button.dataset.alt) productMainImage.alt = button.dataset.alt;
      galleryButtons.forEach((option) => option.classList.toggle('is-active', option === button));
    });
  });

  formatButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('is-disabled')) return;

      formatButtons.forEach((option) => option.classList.toggle('is-selected', option === button));

      if (button.dataset.packagingValue) {
        productPackagingProperties.forEach((input) => {
          input.value = button.dataset.packagingValue;
        });
        galleryButtons.forEach((option) => option.classList.remove('is-active'));
      }

      if (button.dataset.variantId) {
        productVariantInputs.forEach((input) => {
          input.value = button.dataset.variantId;
        });
      }

      if (!productMainImage || !button.dataset.image) return;
      productMainImage.src = button.dataset.image;
      if (button.dataset.alt) productMainImage.alt = button.dataset.alt;
    });
  });

  const supplyButtons = document.querySelectorAll('[data-supply-option]');
  const productQuantityInputs = document.querySelectorAll('[data-product-quantity]');
  const productOfferProperties = document.querySelectorAll('[data-product-offer-property]');
  const productBonusProperties = document.querySelectorAll('[data-product-bonus-property]');
  const productAddLabels = document.querySelectorAll('[data-product-add-label]');

  supplyButtons.forEach((button) => {
    button.addEventListener('click', () => {
      supplyButtons.forEach((option) => option.classList.toggle('is-selected', option === button));

      if (button.dataset.quantity) {
        productQuantityInputs.forEach((input) => {
          input.value = button.dataset.quantity;
        });
      }

      productOfferProperties.forEach((input) => {
        input.value = button.dataset.offerLabel || '';
      });

      productBonusProperties.forEach((input) => {
        const bonusLabel = button.dataset.bonusLabel || '';
        input.value = bonusLabel;
        input.disabled = !bonusLabel;
      });

      if (button.dataset.buttonLabel) {
        productAddLabels.forEach((label) => {
          label.textContent = button.dataset.buttonLabel;
        });
      }
    });
  });

  const reviewTrack = document.querySelector('[data-review-track]');
  const reviewPrev = document.querySelector('[data-review-prev]');
  const reviewNext = document.querySelector('[data-review-next]');
  document.querySelectorAll('.review-bars').forEach((bars) => bars.remove());
  document.querySelectorAll('.product-ingredients-visual').forEach((visual) => visual.remove());

  const scrollReviews = (direction) => {
    if (!reviewTrack) return;
    const firstCard = reviewTrack.querySelector('.community-review-card');
    const gap = Number.parseFloat(window.getComputedStyle(reviewTrack).columnGap || '0');
    const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : reviewTrack.clientWidth;
    reviewTrack.scrollBy({ left: direction * distance, behavior: 'smooth' });
  };

  reviewPrev?.addEventListener('click', () => scrollReviews(-1));
  reviewNext?.addEventListener('click', () => scrollReviews(1));

  const productReviewVideoTrack = document.querySelector('[data-product-review-video-track]');
  const productReviewVideoNext = document.querySelector('[data-product-review-video-next]');

  if (productReviewVideoTrack && productReviewVideoNext) {
    const updateProductReviewVideoNext = () => {
      const canScroll = productReviewVideoTrack.scrollWidth - productReviewVideoTrack.clientWidth > 10;
      const isAtEnd = productReviewVideoTrack.scrollLeft + productReviewVideoTrack.clientWidth >= productReviewVideoTrack.scrollWidth - 10;
      productReviewVideoNext.hidden = !canScroll || isAtEnd;
    };

    productReviewVideoNext.addEventListener('click', () => {
      productReviewVideoTrack.scrollBy({
        left: Math.round(productReviewVideoTrack.clientWidth * 0.86),
        behavior: 'smooth'
      });
    });

    productReviewVideoTrack.addEventListener('scroll', updateProductReviewVideoNext, { passive: true });
    window.addEventListener('resize', updateProductReviewVideoNext);
    updateProductReviewVideoNext();
  }

  const productTimeline = document.querySelector('.product-timeline');
  const productTimelineItems = productTimeline ? Array.from(productTimeline.querySelectorAll('article')) : [];

  if (productTimeline && productTimelineItems.length) {
    let timelineFrame = null;

    const updateProductTimeline = () => {
      timelineFrame = null;
      const timelineRect = productTimeline.getBoundingClientRect();
      const triggerY = window.innerHeight * 0.5;
      const firstDot = productTimelineItems[0].offsetTop + 9;
      const lastDot = productTimelineItems[productTimelineItems.length - 1].offsetTop + 9;
      const localTrigger = triggerY - timelineRect.top;
      const progress = Math.max(0, Math.min(1, (localTrigger - firstDot) / Math.max(1, lastDot - firstDot)));
      let activeIndex = 0;

      productTimelineItems.forEach((item, index) => {
        const dotTop = item.offsetTop + 9;
        if (localTrigger >= dotTop - 30) activeIndex = index;
      });

      productTimeline.style.setProperty('--timeline-progress', `${(progress * Math.max(1, lastDot - firstDot)).toFixed(1)}px`);
      productTimelineItems.forEach((item, index) => {
        item.classList.toggle('active', index === activeIndex);
      });
    };

    const requestProductTimelineUpdate = () => {
      if (timelineFrame) return;
      timelineFrame = window.requestAnimationFrame(updateProductTimeline);
    };

    window.addEventListener('scroll', requestProductTimelineUpdate, { passive: true });
    window.addEventListener('resize', requestProductTimelineUpdate);
    updateProductTimeline();
  }

  const capsuleWaitlistModal = document.querySelector('[data-capsule-waitlist-modal]');
  const capsuleWaitlistOpenButtons = document.querySelectorAll('[data-capsule-waitlist-open]');
  const capsuleWaitlistCloseButtons = document.querySelectorAll('[data-capsule-waitlist-close]');

  const setCapsuleWaitlistOpen = (isOpen) => {
    if (!capsuleWaitlistModal) return;
    capsuleWaitlistModal.classList.toggle('is-open', isOpen);
    capsuleWaitlistModal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle('quiz-modal-lock', isOpen);
    if (isOpen) {
      window.setTimeout(() => capsuleWaitlistModal.querySelector('input[type="email"]')?.focus(), 80);
    }
  };

  capsuleWaitlistOpenButtons.forEach((button) => {
    button.addEventListener('click', () => setCapsuleWaitlistOpen(true));
  });

  capsuleWaitlistCloseButtons.forEach((button) => {
    button.addEventListener('click', () => setCapsuleWaitlistOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setCapsuleWaitlistOpen(false);
  });

  const verifiedReviewGrid = document.querySelector('[data-verified-review-grid]');
  const verifiedReviewPagination = document.querySelector('[data-verified-review-pagination]');
  const verifiedReviewCards = verifiedReviewGrid ? Array.from(verifiedReviewGrid.querySelectorAll('article')) : [];
  const verifiedReviewsPerPage = 12;

  if (verifiedReviewGrid && verifiedReviewPagination && verifiedReviewCards.length > verifiedReviewsPerPage) {
    const pageCount = Math.ceil(verifiedReviewCards.length / verifiedReviewsPerPage);
    let activePage = 1;

    const showVerifiedReviewPage = (page) => {
      activePage = page;
      verifiedReviewCards.forEach((card, index) => {
        const cardPage = Math.floor(index / verifiedReviewsPerPage) + 1;
        card.classList.toggle('is-hidden', cardPage !== activePage);
      });
      verifiedReviewPagination.querySelectorAll('button').forEach((button) => {
        const isActive = Number(button.dataset.reviewPage) === activePage;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'page' : 'false');
      });
    };

    for (let page = 1; page <= pageCount; page += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.reviewPage = String(page);
      button.textContent = String(page);
      button.setAttribute('aria-label', `Review Seite ${page}`);
      button.addEventListener('click', () => {
        showVerifiedReviewPage(page);
        verifiedReviewGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      verifiedReviewPagination.appendChild(button);
    }

    showVerifiedReviewPage(1);
  }
})();
